/**
 * My Profile (/profile) — full-page UserDrawer with sidebar tabs.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
import { UserDrawer } from '../components/UserDrawer.js';

export function ProfilePage() {
  const auth = useAuth();
  const navigate = useNavigate();

  if (auth.status !== 'authenticated') return null;
  const user = auth.user;

  return (
    <div className="h-[calc(100vh-3.5rem)]">
      <UserDrawer
        userId={user.userId}
        onClose={() => navigate('/')}
        canEdit={true}
        isSelf={true}
      />
    </div>
  );
}
